/* eslint react/prop-types: 0 */
import React from 'react'
import Select from 'react-select'
import { FormInput } from 'camino-react'

const ResponseCondition = ({
  update,
  predicates: { by, client_id: clientID },
  options: { clients }
}) => {
  const byOptions = [
    { label: 'Calligo', value: 'calligo' },
    { label: 'Client', value: 'client' },
    { label: 'Specified Client', value: 'client_id' }
  ]

  return (
    <div>
      <FormInput label="Who">
        <Select
          options={byOptions}
          value={by}
          onChange={e => update('by', e.value)}
        />
      </FormInput>

      {by === 'client_id' && (
        <FormInput label="Client ID">
          <Select
            options={clients}
            value={clientID}
            onChange={e => update('client_id', e.value)}
          />
        </FormInput>
      )}
    </div>
  )
}

export default ResponseCondition
